// This is the entry point for reCAPTCHA JS. Add JavaScript imports here.
import './recaptcha';
